// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"477":"banner-homepage-jp-BottomBanner","881":"banner-homepage-jp-TopBanner"}[chunkId] || chunkId) + "." + {"121":"0a58e526","146":"bce4f23d","178":"3d2d1c73","305":"307bd3de","306":"2c667a60","333":"e4f3b555","477":"5e06c59e","581":"25dc1598","666":"2fd625cd","881":"96ddaef4"}[chunkId] + ".chunk.js";
};